<template>
  <IndicatorWrapper class="sector-evol" :status="status" v-if="visible">
    <div class="top">
      <TextWithFilters ref="textComponent" textKey="sector_evol_text_with_filters" :textData="dynamicTextData" v-model="currentFilters" shareTextKey="sector_evol_text_share"></TextWithFilters>
    </div>
    <div class="bottom">
      <SectorBarChart :data="indicatorData.evolutive" :status="evolutiveStatus" :sector="currentFilters.sector_sector_evol" :compareData="indicatorData.compare_data"></SectorBarChart>
      <ChartLegend :items="legendItems" v-show="isCompareMode"></ChartLegend>
      <ChartDescription :values="currentFilters" :indicator="indicator" descriptionKey="sector_evol_info"></ChartDescription>
    </div>
  </IndicatorWrapper>
</template>

<script>
import Api from '@/api'
import indDynamicText from '@/mixins/indDynamicText'
import indData from '@/mixins/indData'
import TextWithFilters from '@/components/IndicatorCards/parts/TextWithFilters'
import SectorBarChart from '@/components/IndicatorCards/parts/charts/SectorBarChart'
import ChartDescription from '@/components/IndicatorCards/parts/ChartDescription'
import ChartLegend from '@/components/IndicatorCards/parts/ChartLegend'
import IndicatorWrapper from '@/components/IndicatorCards/parts/IndicatorWrapper'
import data from '@/assets/fake_data/generics/evol_sector.json'
import data2 from '@/assets/fake_data/generics/evol_sector_NEW.json'
import moment from 'moment';
import {capitalize} from '@/utils/textUtils'

export default {
  name: 'SectorEvol',

  mixins: [indData, indDynamicText],

  components: {
    TextWithFilters,
    ChartDescription,
    SectorBarChart,
    IndicatorWrapper,
    ChartLegend
  },
  computed: {
    evolutiveStatus () {
      // return (!this.indicatorData['evolutive'] || this.$asyncComputed['asc_evolutive'].updating) ? {status:'fetching'} : {status:'ready'}
      if(this.$asyncComputed['asc_evolutive'].updating) return {status:'fetching'}
      else if(!this.indicatorData['evolutive']) return {status:'no-data'}
      else return {status:'ready'}
    },
    indicatorData() {
      return {
        evolutive: {
          required: false,
          get () {
            return Api.getIndicatorData('evol_var_sector_month', this.currentFilters)
            // return new Promise(res=>res(data))
            // if(Math.random()>0.5) return new Promise(res=>res(data))
            // else return new Promise(res=>res(data2))
          }
        },
        compare_data: {
          required: false,
          triggers_jump: false,
          get () {
            return this.isCompareMode ? Api.getIndicatorData('evol_var_sector_month',this.currentFilters, {
              node: this.compareNodeInfo,
              avoidCancel: true
            }) :
            Promise.resolve(false)
          }
        }
      }
    },
    dynamicTextData () {
      let evolData = this.indicatorData.evolutive && this.indicatorData.evolutive.data[0] && this.indicatorData.evolutive.data[0].data
      
      let firstMonth, lastMonth
      if(evolData) {
        firstMonth = evolData[0]
        lastMonth = evolData[evolData.length - 1]
      }

      return [
        {
          type: 'select',
          id: 'sector_sector_evol',
        },
        {
          type: 'value',
          id: 'VALUE_1',
          value: firstMonth && firstMonth.data ? firstMonth.data[0].value : '--',
          unit: '%'
        },
        {
          type: 'value',
          id: 'MONTH_1',
          value: firstMonth ? capitalize(moment(firstMonth.valueDate).format('MMMM')) : '--',
        },
        {
          type: 'value',
          id: 'VALUE_2',
          value: lastMonth && lastMonth.data ? lastMonth.data[0].value : '--',
          unit: '%'
        },
        {
          type: 'value',
          id: 'MONTH_2',
          value: lastMonth ? capitalize(moment(lastMonth.valueDate).format('MMMM')) : '--',
        }
      ]
    },
  }
}
</script>

<style lang="stylus" scoped>
.sector-evol
  .bottom
    .desktop &
      margin-top: vh(-60px)
</style>